module.exports = __webpack_public_path__ + "0a4bc548dc590de0d6d0489d6a344157.svg";